import React, { useEffect } from "react";
const ImportantLink = (props) => {
  function redirectToMCustomer() {
    const form = document.getElementById("MCustomer");
    form.action =window.envType === "DEV" ?
      "https://dev-api-auth.bhartiaxa.com/public/api/v1/auth/externalLogin" : 
      window.envType === "NEWGEN-UAT" ?
      "https://pphi-uat-api-auth.bhartiaxa.com/public/api/v1/auth/externalLogin" : 
       window.envType === "PROD" ?
      "https://api-auth.bhartiaxa.com/public/api/v1/auth/externalLogin" :''
    form.submit();
  }
  useEffect(() => {
    // console.log("==============>", props.proposalData)
  });
  console.log('props.proposalData?.uniqueProposalId}',props.proposalData?.uniqueProposalId)
  const paymentLinks =
    props.proposalData?.paymentDetails?.methodsOfPayments?.filter(
      (item) => item?.link
    ) || [];

  return (
    <div className="main_container">
      {props.proposalData?.consentDetails?.fincareConsentLink && (
        <div className="imp-link">
          <a
            href={props.proposalData.consentDetails.fincareConsentLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            Fincare Consent Link 
          </a>
        </div>
      )}
      {props.proposalData?.consentDetails?.utkarshBankConsentLink && (
        <div className="imp-link">
          <a
            href={props.proposalData.consentDetails.utkarshBankConsentLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            Utkarsh Bank Consent Link
          </a>
        </div>
      )}

      {paymentLinks.map((item, index) => (
          <div className="imp-link" key={item.id || index}>
            <a
              href={item.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              Payment link{paymentLinks.length > 1 ? ` ${index + 1}` : ""}
            </a>
          </div>
        ))}

      {props.proposalData?.consentDetails?.customerConsentLink && (
        <div  className="imp-link">
          <a
            href={props.proposalData.consentDetails.customerConsentLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            Customer consent link
          </a>
        </div>
      )}

      {props.proposalData?.consentDetails?.agentConsentLink && (
        <div className="imp-link">
          <a
            href={props.proposalData.consentDetails.agentConsentLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            Agent Consent link
          </a>
        </div>
      )}

      {props.proposalData?.paymentDetails?.renewal?.enach && (
        <div className="imp-link">
          <h6>Enach link:</h6>
          <a
            href={props.proposalData.paymentDetails.renewal.enach}
            target="_blank"
            rel="noopener noreferrer"
          >
            Enach link
          </a>
        </div>
      )}

      {/* <h1>Redirect To MCustomer</h1> */}
      <div Style={{ display: "none" }}  className="imp-link">
        <form id="MCustomer" target="_blank" method="POST">
          <input type="hidden" name="source" value="D2C" />
          <input
            type="hidden"
            name="jwtToken"
            // value="R0dJdTVJWmx6RmN0S0tzT1o4dk93QT09"
            value={props.proposalData?.uniqueProposalId}
          />
        </form>

        <a
          href="#"
          className="trigger-btn"
          onClick={(e) => {
            e.preventDefault();
            redirectToMCustomer();
          }}
        >
          DropOff Link
        </a>
      </div>
    </div>
  );
};

export default ImportantLink;
